import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { LeaderAudiencesLoadFulfilledAction } from '../../domains/leadersManagement/loadLeaderAudiencesActions.types';

import { Audiences } from './types';

export type AudienceAction = LeaderAudiencesLoadFulfilledAction;

const initialState: Audiences = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<Audiences, AudienceAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'LEADER_AUDIENCES.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.audiences);
    default:
      return state;
  }
};

export default reducer;
